(() => {
  if (customElements.get('featured-product-gallery')) return;
  customElements.define('featured-product-gallery', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      clearTimeout(this.hoverTimer);
      this.events?.abort();
      this.removeAttribute('data-hover-active');
      this.removeAttribute('data-ready');
    }

    initialize() {
      if (!this.isConnected || this.hasAttribute('data-ready')) return;
      this.track = this.querySelector('[data-featured-gallery-track]');
      this.slides = [...this.querySelectorAll('[data-featured-gallery-slide]')];
      this.indicators = [...this.querySelectorAll('[data-featured-gallery-indicator]')];
      if (!this.track || this.slides.length < 2) return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.index = 0;
      this.select(0, false);
      this.setAttribute('data-ready', '');
      const imageArea = this.closest('.product-item__image');
      imageArea.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) return;
        this.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(() => {
          this.select(this.index + 1, false);
          this.setAttribute('data-hover-active', '');
        }, 220);
      }, options);
      this.querySelector('[data-gallery-previous]').addEventListener('click', () => this.select(this.index - 1), options);
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.select(this.index + 1), options);
      this.indicators.forEach((button, index) => button.addEventListener('click', () => this.select(index), options));
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      // Keep gallery controls independent of the outer product slider's drag handler.
      this.addEventListener('pointerdown', event => event.stopPropagation(), options);
      this.addEventListener('mousedown', event => event.stopPropagation(), options);
      imageArea.addEventListener('pointerleave', () => {
        this.removeAttribute('data-hover-active');
        this.select(0, false);
      }, options);
    }

    select(index, animate = true) {
      clearTimeout(this.hoverTimer);
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.toggleAttribute('data-gallery-animate', animate);
      this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
      this.slides.forEach((slide, i) => {
        slide.tabIndex = i === this.index ? 0 : -1;
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.indicators.forEach((indicator, i) => {
        indicator.classList.toggle('is-active', i === this.index);
        indicator.setAttribute('aria-pressed', String(i === this.index));
      });
    }
  });
})();
